import { useIsNarrow } from './useIsNarrow';
import { isWeb } from '../utils/webOnly';

// True on the phone layout of the web app / Capacitor native (viewport at or
// under the 768px mobile breakpoint AND running through the web/native shim).
// Always false on Electron desktop, whatever the window size — so desktop
// markup stays byte-identical when a component branches on this.
export function useIsMobileWeb() {
    const narrow = useIsNarrow();
    return isWeb && narrow;
}
